import type { FitProfile } from './fit';
import type { SeatCandidate } from './seat-identity';
import type { SeatDecisionRecord } from './seat-decision';
import { initialViewingPlan, type ViewingHistoryEntry, type ViewingPlan } from './viewing-journey';

export interface LocalState {
  candidates: SeatCandidate[];
  reviews: LocalReview[];
  fitProfile: FitProfile;
  recentVenueIds: string[];
  viewingPlan: ViewingPlan;
  upcomingPlans: ViewingPlan[];
  viewingPlanHistory: ViewingHistoryEntry[];
  seatDecisions: SeatDecisionRecord[];
}

export type ReviewDimension = '시야' | '가림' | '소리' | '무릎' | '의자' | '출입';

export interface LocalReview {
  id: string;
  candidateId: string;
  /** The seat at the time of the private note; survives removal from the shortlist. */
  candidateSnapshot?: SeatCandidate;
  scores: Record<ReviewDimension, number | null>;
  note: string;
  actualPaid: number | null;
  observedAt: string;
  verification: 'unverified';
  createdAt: string;
}

export const initialLocalState: LocalState = {
  candidates: [],
  reviews: [],
  fitProfile: {
    heightBand: null,
    knee: null,
    neckBack: null,
    soundLight: null,
    mobilityNeed: null,
  },
  recentVenueIds: [],
  viewingPlan: initialViewingPlan,
  upcomingPlans: [],
  viewingPlanHistory: [],
  seatDecisions: [],
};
